import { render, staticRenderFns } from "./ModattaAchievements.vue?vue&type=template&id=6fc52393"
import script from "./ModattaAchievements.vue?vue&type=script&lang=js"
export * from "./ModattaAchievements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports